import React from "react";

export function SearchIcon({
  size = 16,
  color = "currentColor",
  style,
  ...props
}) {
  const uniqueId = React.useMemo(
    () => Math.random().toString(36).slice(2, 10),
    []
  );
  const clipPathId = `search-clip-${uniqueId}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color, ...style }}
      {...props}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.0013 0.666016C3.5035 0.666016 0.667969 3.50155 0.667969 6.99935C0.667969 10.4972 3.5035 13.3327 7.0013 13.3327C8.51007 13.3327 9.89561 12.8051 10.9835 11.9244L14.1966 15.1375L15.1394 14.1947L11.9263 10.9816C12.8071 9.89366 13.3346 8.50811 13.3346 6.99935C13.3346 3.50155 10.4991 0.666016 7.0013 0.666016ZM2.0013 6.99935C2.0013 4.23793 4.23988 1.99935 7.0013 1.99935C9.76273 1.99935 12.0013 4.23793 12.0013 6.99935C12.0013 9.76077 9.76273 11.9993 7.0013 11.9993C4.23988 11.9993 2.0013 9.76077 2.0013 6.99935Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SearchActiveIcon({
  size = 16,
  color = "currentColor",
  style,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      style={{ color, ...style }}
      {...props}
    >
      <path
        d="M10.6667 6.33333C10.6667 8.72657 8.72657 10.6667 6.33333 10.6667C3.9401 10.6667 2 8.72657 2 6.33333C2 3.9401 3.9401 2 6.33333 2C8.72657 2 10.6667 3.9401 10.6667 6.33333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.33333C0 2.83553 2.83553 0 6.33333 0C9.83114 0 12.6667 2.83553 12.6667 6.33333C12.6667 7.8421 12.1391 9.22764 11.2584 10.3155L14.4715 13.5286L13.5286 14.4715L10.3155 11.2584C9.22764 12.1391 7.8421 12.6667 6.33333 12.6667C2.83553 12.6667 0 9.83114 0 6.33333ZM6.33333 1.33333C3.57191 1.33333 1.33333 3.57191 1.33333 6.33333C1.33333 9.09476 3.57191 11.3333 6.33333 11.3333C9.09476 11.3333 11.3333 9.09476 11.3333 6.33333C11.3333 3.57191 9.09476 1.33333 6.33333 1.33333Z"
        fill="currentColor"
      />
    </svg>
  );
}
